<template>
  <div class="detalles">
    <Detalles_Components />
  </div>
</template>

<script>
import Detalles_Components from "@/components/Detalles_Components.vue";
export default {
  name: "Detalles",
  components: {
    Detalles_Components,
  },
};
</script>

<style></style>
